module.exports = {"Born1":{"daobanList":[{"title":"1:是否办理个人创业一件事","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、广东省个人创业“一件事”（第二阶段事项）申请表","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx41.json
// module id = 1338
// module chunks = 0